export default __webpack_public_path__ + "static/media/Health_Plan_Brochure.7e5dcd46.pdf";